import { render, staticRenderFns } from "./allcompany.vue?vue&type=template&id=fa7ea806&"
import script from "./allcompany.vue?vue&type=script&lang=js&"
export * from "./allcompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports